import React from 'react';
import able1 from '../assets/able1.png';
import able2 from '../assets/able2.png';
import able3 from '../assets/able3.png';
import ModernResources from './modern/ModernResources';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
const RESOURCES = [
  {
    img: able1,
    title: "WorkBC inclusive career resources",
    text: "Build your own career plan and find B.C. resources to choose a career, access education and funding, and get a job.",
    href: 'https://www.workbc.ca/plan-career/inclusive-career-resources/people-disabilities',
  },
  {
    img: able2,
    title: "Opportunities Fund projects",
    text: "Projects across Canada funded by the Opportunities Fund for Persons with Disabilities to help people prepare for, find and keep jobs.",
    href: 'https://www.canada.ca/en/employment-social-development/programs/opportunity-fund-disability/active-projects.html',
  },
  {
    img: able3,
    title: "Job Bank: persons with disabilities",
    text: "Job Bank information on inclusive hiring and workplace accommodations for persons with disabilities.",
    href: 'https://www.jobbank.gc.ca/hiring/persons-with-disabilities',
  },
];

export default function Resources() {
  return <ModernResources items={RESOURCES} />;
}
